// extracted by mini-css-extract-plugin
export default {"mention":"Lexer_mention__qGFNd","mentionDisabled":"Lexer_mentionDisabled__zzyfV","mentionOverlay":"Lexer_mentionOverlay__njsJI"};